import emptyFunction from 'react-utils/emptyFunction';
function getFeedbackInstance() {
  if ('hsFeedback' in window) {
    return window.hsFeedback;
  }
  return {
    loadSurvey: emptyFunction,
    renderSurvey: emptyFunction,
    reset: emptyFunction
  };
}
export const loadSurvey = (type, id) => {
  const feedbackInstance = getFeedbackInstance();
  feedbackInstance.loadSurvey(type, id);
};